module.exports = __webpack_public_path__ + "static/media/payu.7bf47816.png";